import React,{Component} from 'react';

import { Helpers } from '../../core/src/helpers';

import '../css/pdp-cn-redirect.less';

class CanadaPopup extends Component {

    constructor() {
        super();
        this.state = {
            showModal:true
        }
        this.handleLoadPopup();
        
    }
    
    closePopup = (e) => {
        e.preventDefault();
        Helpers.hpUtilTrackEvent({
            base:"close",
            prefix: "canada-popup",
            omni: "var1",
            errorMessage: `canada popup failed to track data: click-close`
          });

        this.setState({
            showModal:false
        })
    }

    handleLoadPopup = () => {
        setTimeout(function() {
            Helpers.hpUtilTrackEvent({
                base:"open",
                prefix: "canada-popup",
                omni: "var1",
                errorMessage: `canada popup failed to track data: open-popup`
              });
        },2000);
    };

    visitCanadaStore = (e) => {
        e.preventDefault();
        Helpers.hpUtilTrackEvent({
            base:"click-castore",
            prefix: "canada-popup",
            omni: "var1",
            errorMessage: `canada popup failed to track data: click-castore`
          });
          location.href = this.props.urlProp;
    };

    visitUSStore = (e) => {
        e.preventDefault();
        Helpers.hpUtilTrackEvent({
            base:"click-usstore",
            prefix: "canada-popup",
            omni: "var1",
            errorMessage: `canada popup failed to track data: click-usstore`
          });

          this.setState({
            showModal:false
        })
          
    };

    render() {
        
        return (
            <div id="caModal" className={`camodal${this.state.showModal ? "" : " camodalClosed"}`}>
                <div className="camodal-content">
                    <a href="" className="caclose" onClick={this.closePopup}>&times;</a>
                    <div className="middle">
                        <h3>It looks like you're shopping from Canada.<br/>
                        Visit our Canadian online store and get free shipping on all orders.
                        </h3>
                        <a onClick={this.visitCanadaStore}  href="" className="box1">
                            <span><img src="https://www.hp.com/us-en/shop/app/static/images/canada.png"/><br/>Shop the <br/>Canadian Store</span>
                        </a>
                        <a onClick={this.visitUSStore} href="" className="box2">
                            <span>
                                <img src="https://www.hp.com/us-en/shop/app/static/images/us_flag_2.png"/><br/>
                                Continue shopping<br/> the U.S. Store</span>
                        </a>
                    </div>
                </div>

            </div>
        )
    }

}

export default CanadaPopup;